<script>
   /*************************************************************/
   /* AppPlots global component for plots routing               */
   /* -------------------------------                           */
   /* show list of plots and let user to select one, and        */
   /* interact with it.                                         */
   /*************************************************************/

	import { createEventDispatcher } from 'svelte';

   // import plot and plot controls components
   import Container from '../../../shared/controls/Container.svelte';
   import Button from '../../../shared/controls/Button.svelte';


   /*****************************************/
   /* Component parameters                  */
   /*****************************************/

   // imputs
   export let model;
   export let simcares;
   export let pcares;
   export let datasets;
   export let options;
   export let ncomp;


   /*****************************************/
   /* Component code                        */
   /*****************************************/

   // index of selected object and variable
   let selected_object = -1;

   // selected plot number and its parameters
   let plot_container;
   let params = null;
   let selected_plot_index = 0;
   let selected_plot = options[selected_plot_index];

   // event dispatcher
   const dispatch = createEventDispatcher();

   // function to switch between plots
   function switchPlot(i) {
      params = null;
      selected_plot_index = i;
      selected_plot = options[selected_plot_index]
   }

   // function to dispatch event when outlier is marked
   function markOutlier(el) {
      dispatch('setoutlier', {id: selected_object});
   }

   function plotOutlier(el) {
      dispatch('plotoutlier', {id: selected_object});
   }
</script>

<div class="plot-container">

   <!-- column with current plot -->

   <div bind:this={plot_container} class="plot-area">
      {#if selected_plot.scope === 'objects'}
      <svelte:component
         this={selected_plot.plotComponent}
         bind:selected={selected_object}
         res={simcares}
         {params}
         {ncomp}
      />
      {:else if selected_plot.scope === 'model'}
      <svelte:component
         this={selected_plot.plotComponent}
         {model}
         {params}
      />
      {:else if selected_plot.scope === 'scores'}
      <svelte:component
         this={selected_plot.plotComponent}
         bind:selected={selected_object}
         {pcares}
         {datasets}
         {params}
      />
      {:else if selected_plot.scope === 'scores-ns'}
      <svelte:component
         this={selected_plot.plotComponent}
         {pcares}
         {datasets}
         {params}
      />
      {:else}
      <svelte:component
         this={selected_plot.plotComponent}
         res={simcares}
         {params}
         {ncomp}
      />
      {/if}
   </div>

   <!-- column with plot selectors and current plot settings -->
   <div class="plot-controls-area">
      {#each options as {label, scope, plotComponent, controlsComponent}, i}
         {#if selected_plot_index === i}
            {#if scope === 'objects'}
            <svelte:component this={controlsComponent} bind:params={params} res={simcares} />
            {:else if scope === 'model'}
            <svelte:component this={controlsComponent} bind:params={params} {model} />
            {:else if scope === 'scores' || scope === 'scores-ns'}
            <svelte:component this={controlsComponent} bind:params={params} res={pcares} />
            {:else}
            <svelte:component this={controlsComponent} bind:params={params} res={simcares} />
            {/if}

            {#if (scope === 'objects' || scope === 'scores') && selected_object >= 0}
            <Container label="Selected">
               <div class="buttons button-outlier">
               <Button on:click={plotOutlier}>plot</Button>
               <Button on:click={markOutlier}>remove</Button>
               </div>
            </Container>
            {/if}
         {:else}
         <button
            class="plot-selector"
            on:keydown={() => switchPlot(i)}
            on:click={() => switchPlot(i)}
         >{label}</button>
         {/if}
      {/each}
   </div>
</div>


<style>
   .plot-controls-area > :global(.control-element:has(.button-outlier)) {
      background: #fff0e8;
   }

   .button-outlier  :global(span:last-child > button) {
      color: white;
      border-color: crimson;
      background: crimson;
   }

   .button-outlier  :global(span:last-child > button:hover) {
      background: #DC143C20;
      border-color: #DC143C80;
      color: crimson;
   }

   .buttons {
      position: relative;
      box-sizing: border-box;
      display: inline-block;
      flex: 1 1 auto;
      margin: 0;
      padding: 2px 0;
      width: auto;
      border-radius: 2px;
      cursor: default;
   }

   .plot-container {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 0;
      display: grid;
      grid-template-rows: 1fr;
      grid-template-columns: 1fr minmax(270px, 30%);
   }

   .plot-area {
      padding: 1em;
      margin-top: 0.25rem;
      border-radius: 0.25em;
      background: #fefefe;
   }

   .plot-controls-area {
      padding: 0 0.25em 0 0.5em;
   }

   .plot-selector {
      cursor: pointer;
      color: #606060;
      background: #fffef480;
      box-sizing: border-box;
      padding: 0.5em 1em;
      margin: 0.25em 0;
      border-radius: 0.25rem;
      box-shadow: none;
      border: none;
      width: 100%;
      text-align: left;
      font-size: 1rem;
   }

   .plot-selector:hover {
      background: #e0e0e0;
      color: #403020;
   }

   :global(div.plot-container.off-screen) {
      position:absolute;
      top:0;
      left:50%;
      width: 650px;
      height: 600px;
      background: white;
      z-index: 999;
   }

   @media(min-width:1100px) {
      .plot-container {
         grid-template-columns: 1fr minmax(285px, 30%);
      }
   }

   @media(min-width:1300px) {
      .plot-container {
         grid-template-columns: 1fr max(300px, 30%);
      }
   }

   @media(min-width:1600px) {
      .plot-container {
         grid-template-columns: 1fr 400px;
      }
   }

</style>